module.exports = __webpack_public_path__ + "static/media/shorts-pending-icon-1.f728d755.png";